import { Component } from "@angular/core";
import { StartNgIdleService } from "./shared/services/ng-idle-startup/start-ng-idle.service";
import { RouteEventsService } from "./shared/services/route-events/route-events.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent {
  timeOutModal = false;
  constructor(
    private timeOutService: StartNgIdleService,
    // @ts-ignore
    private routeEvent: RouteEventsService, // important, do not remove
  ) {
    this.timeOutService.getTimeout().subscribe((timeOut) => {
      this.timeOutModal = timeOut as boolean;
    });
  }

  closeTimeOut() {
    this.timeOutModal = false;
  }
}
